{
  "name": "@chancenwerk/chancen-board",
  "displayName": "ChancenBoard",
  "description": "The ChancenBoard is the internal course assignment service of the Chancenwerk e.V.",
  "version": "2.0.2",
  "private": true,
  "type": "module",
  "scripts": {
    "build": "adornis-cli project build --production --node-port 7000 --listen-port 3000",
    "test": "adornis-cli project test"
  },
  "dependencies": {
    "@adornis/base": "catalog:",
    "@adornis/ass": "catalog:",
    "@adornis/baseql": "catalog:",
    "@adornis/calendar": "catalog:",
    "@adornis/chemistry": "catalog:",
    "@adornis/cms": "catalog:",
    "@adornis/config": "catalog:",
    "@adornis/data-view": "catalog:",
    "@adornis/filter": "catalog:",
    "@adornis/fonts": "catalog:",
    "@adornis/forms": "catalog:",
    "@adornis/functional-lit": "catalog:",
    "@adornis/internationalization": "catalog:",
    "@adornis/dialog": "catalog:",
    "@adornis/file-utils": "catalog:",
    "@adornis/entity-picker": "catalog:",
    "@adornis/pagination": "catalog:",
    "@adornis/dragdrop": "catalog:",
    "@adornis/router": "catalog:",
    "@adornis/user-forms": "catalog:",
    "@adornis/users": "catalog:",
    "@chancenwerk/client": "workspace:^",
    "@chancenwerk/translation-data": "workspace:^",
    "@chancenwerk/shared": "workspace:^",
    "@chancenwerk/server": "workspace:^",
    "@chancenwerk/config": "workspace:^",
    "@chancenwerk/enums": "workspace:^",
    "@chancenwerk/work-tracking": "workspace:^",
    "@lit-labs/preact-signals": "catalog:",
    "construct-style-sheets-polyfill": "catalog:",
    "lit": "catalog:",
    "luxon": "catalog:",
    "mingo": "catalog:",
    "node-schedule": "catalog:",
    "rxjs": "catalog:"
  },
  "devDependencies": {
    "@adornis/cli": "catalog:",
    "@adornis/testing": "catalog:",
    "mocha": "catalog:"
  },
  "files": [
    "dist"
  ],
  "license": "ISC"
}
